import React, { useContext } from 'react';
import { ThemeProvider } from './ThemeProvider';
import { configurationContext } from 'src/contexts/configuration/context';

export const ThemeWrapper = ({ children }: React.PropsWithChildren<{}>) => {
	const { theme: themeName } = useContext(configurationContext);

	return <ThemeProvider themeName={themeName}>{children}</ThemeProvider>;
};
